export const menuLinkStyle =
  "inline-flex items-center font-sans text-xs transition text-black! visited:text-black! hover:bg-gray-50 focus-visible:[outline:revert] py-3.5 px-2.5"
